/* ════ GANTT GEOMETRY ══════════════════════════════════════ */
import { state } from '../state.js';
import { ddiff, pdate, fdate, addD } from '../utils/date.js';

// Column index (within the current view window) for a given date string.
export const dayIdx = s => ddiff(state.viewStart, pdate(s));

// Tasks are modelled in half-day units relative to viewStart. End dates are
// INCLUSIVE (a task ending "10 Jun" runs through the end of 10 Jun), so the
// exclusive right boundary of a full end day is (dayIdx(end)+1)*2.
//   half==='pm'   → starts on the afternoon of the start day
//   half==='am'   → ends at midday of the end day (morning only)
//   half==='pmam' → both (starts PM and ends AM)
const startsPM = h => h === 'pm' || h === 'pmam';
const endsAM = h => h === 'am' || h === 'pmam';
export const startHalf = t => dayIdx(t.start) * 2 + (startsPM(t.half) ? 1 : 0);
export const endHalf = t => endsAM(t.half) ? dayIdx(t.end) * 2 + 1 : (dayIdx(t.end) + 1) * 2;

// Inverse: convert an absolute [startHalf, endHalf) range (half-day units from
// viewStart) back into { start, end, half } with inclusive end dates. Every
// range is representable now that 'pmam' covers the both-half-days case, so
// resize/move never snap back.
export function halfRangeToDates(sh, eh) {
  const startDay = Math.floor(sh / 2), startPM = sh % 2 === 1;
  const endAM = eh % 2 === 1, endDay = Math.max(startDay, Math.ceil(eh / 2) - 1);
  const half = startPM && endAM ? 'pmam' : startPM ? 'pm' : endAM ? 'am' : 'none';
  return { start: fdate(addD(state.viewStart, startDay)), end: fdate(addD(state.viewStart, endDay)), half };
}
